import { lighten } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { error, info, neutralDark, success, warning } from '../colors'
import { getPrimary } from '../utils'

export const createPalette = (config) => {
    const { colorPreset, contrast } = config
    const primary = getPrimary(colorPreset)

    return {
        action: {
            active: neutralDark[600],
            // See the note in black/create-palette.js: neutralDark is the
            // reversed scale, so [100] is near-black on a near-black surface.
            disabled: alpha(neutralDark[900], 0.38),
            disabledBackground: alpha(neutralDark[900], 0.12),
            focus: alpha(primary.main, 0.2),
            hover: alpha(primary.main, 0.1),
            selected: alpha(primary.main, 0.16)
        },
        background: {
            default: contrast === 'high' ? '#030305' : '#05060A',
            paper: contrast === 'high' ? '#090B10' : '#0A0D14'
        },
        divider: alpha(primary.main, 0.22),
        error,
        info,
        // MUI and this app only know 'light' and 'dark'; any other name gets light-mode styling.
        mode: 'dark',
        neutral: neutralDark,
        primary,
        success,
        text: {
            primary: '#F4F7FF',
            secondary: '#B5C0D6',
            disabled: 'rgba(255, 255, 255, 0.48)'
        },
        warning
    }
}
